import { IComponentOptions } from "angular";
import {
  getProcessTimelineDetailComponent,
  ProcessTimelineDetailComponentController,
} from "../detailComponent";
import { ProcessInstancesNotesView } from "../../../../../model/ProcessApi";

export const NoteComponentOptions: IComponentOptions =
  getProcessTimelineDetailComponent<
    ProcessInstancesNotesView,
    ProcessTimelineDetailComponentController<ProcessInstancesNotesView>
  >({
    template: require("!html-loader!./index.html").default,
    controller: [
      () =>
        new ProcessTimelineDetailComponentController<ProcessInstancesNotesView>(),
    ],
  });
